<template>
  <PixelWrapper>
    <mp-box
      v-if="!isInitiated && $auth.loggedIn"
      class="centered-item w-100 qon-loading"
    >
      <mp-loader class="page-loader" />
    </mp-box>
    <mp-box v-else class="mp-body">
      <!-- <vue-element-loading
        :active="loadingbar"
        :duration="'0.5'"
        :size="'68'"
        spinner="bar-fade-scale"
        color="#0274f5"
      /> -->
      <!-- <mp-box id="qon-announcement" as="div"> -->
      <BannerMaintenance
        v-if="bannerMaintenance.isShow"
        :banner-maintenance="bannerMaintenance || {}"
        @set-banner-height="setBannerHeight"
      />
      <BannerUserStatus
        v-if="bannerUserStatus.isShow && !quotaBanner.isFeatureActive"
        :banner-user-status="bannerUserStatus"
        :billing-info="billing_info || {}"
        :is-desty="isDestyChatClient"
        @set-banner-height="setBannerHeight"
        @on-close-banner-status="onCloseBannerStatus"
        @redirect-to-customer-care="redirectToCustomerCare"
      />
      <BannerCreditBalance
        v-if="bannerCreditBalance.isShow && !quotaBanner.isFeatureActive"
        :is-chatbot="bannerCreditBalance.isChatbot"
        :banner-credit-balance="bannerCreditBalance || {}"
        :billing-info="billing_info || {}"
        :hide-action="bannerCreditBalance.isHideAction || false"
        :bg-color="bannerCreditBalance.bgColor"
        :is-desty="isDestyChatClient"
        @set-banner-height="setBannerHeight"
        @on-click-banner="onClickBanner"
      />
      <template v-if="quotaBanner.isFeatureActive && isMoveBannerEnabled">
        <template v-for="(item, idx) in quotaBanner.bannerItems">
          <QuotaBanner
            v-if="!dismissedBannerIndices.includes(idx)"
            :key="idx"
            :message="item.message"
            :banner-color-or-type="item.bannerColorOrType"
            :button="item.button"
            :is-closable="item.isClosable"
            @close="onCloseBannerItem(idx)"
          />
        </template>
      </template>
      <QuotaBanner
        v-if="
          quotaBanner.isFeatureActive &&
          !isMoveBannerEnabled &&
          !isSingleBannerDismissed
        "
        :key="0"
        :message="quotaBanner.message"
        :banner-color-or-type="quotaBanner.bannerColorOrType"
        :button="quotaBanner.button"
        :is-closable="quotaBanner.isClosable"
        @close="isSingleBannerDismissed = true"
      />
      <mp-broadcast
        v-if="bannerInformationNewPrice.isShow"
        variant="information"
        icon-name="broadcast"
        content="Starting 1 Nov 2024, service conversations in WhatsApp conversations quota will be free of charge. Information related to service conversations will be removed."
        text-link="Learn more"
        is-closable
        @click-close-button="handleCloseBannerInformation"
        @click-text-link="handleClickLinkBannerInformation"
      />
      <!-- Banner maintenance -->
      <!-- <mp-box
          v-if="bannerInfo.isMaintenance"
          id="qon-announcement-maintenance"
          as="div"
          bg-color="ice.100"
          px="3"
          py="2"
        >
          <mp-flex class="centered-grid-item">
            <mp-icon
              name="warning-triangle"
              color="black"
              variant="fill"
              mr="3"
            />
            <mp-text v-dompurify-html="bannerInfo.output" as="span" />
          </mp-flex>
        </mp-box> -->

      <!-- Banner status user trial/active/grace -->
      <!-- <mp-box
          v-if="warningTrialStatus.isShow || warningFreezeStatus.isShow"
          id="qon-announcement-banner"
          as="div"
          :bg-color="warningTrialStatus.isShow ? 'violet.400' : 'amber.100'"
          px="3"
          py="2"
        >
          <mp-flex justify-content="space-between">
            <mp-flex class="centered-item">
              <mp-icon
                name="warning-circular"
                :color="warningTrialStatus.isShow ? 'white' : 'black'"
                variant="fill"
                mr="3"
              />
              <mp-box font-weight="semibold" ml="2">
                <mp-text
                  v-if="warningTrialStatus.isShow"
                  as="span"
                  color="white"
                  >{{
                    `Your Qontak Omnichannel trial access will expire in ${getExpiredTrial(
                      billingInfo.valid_until
                    )} days. To upgrade your access, please contact the company admin.`
                  }}
                </mp-text>
                <mp-text
                  v-if="warningFreezeStatus.isShow"
                  as="span"
                  color="black"
                  >Your Qontak Omnichannel access is restricted. Please consult
                  further with our support team.
                </mp-text>
                <mp-box
                  v-if="!isAgent()"
                  as="span"
                  :color="warningTrialStatus.isShow ? 'white' : 'black'"
                  text-decoration-line="underline"
                  cursor="pointer"
                  font-weight="regular"
                  @click="redirectToCustomerCare"
                  >Contact support.</mp-box
                >
              </mp-box>
            </mp-flex>
            <mp-box
              v-show="!isAgent()"
              as="div"
              cursor="pointer"
              @click="warningTrialStatus.isShow = false"
            >
              <mp-icon
                v-if="warningTrialStatus.isShow"
                name="close"
                color="white"
                variant="fill"
                mr="3"
                p="1"
              />
            </mp-box>
          </mp-flex>
        </mp-box> -->

      <!-- Banner Credit Balance -->
      <!-- <mp-box
          v-if="bannerCreditBalance.isShow"
          id="qon-announcement-balance"
          as="div"
          bg-color="amber.100"
          px="3"
          py="2"
        >
          <mp-flex justify-content="space-between">
            <mp-flex class="centered-item">
              <mp-icon
                name="warning-triangle"
                color="black"
                variant="fill"
                mr="3"
              />
              <mp-box font-weight="semibold" ml="2">
                <mp-text as="span">{{ bannerCreditBalance.message }} </mp-text> -->
      <!-- <mp-box v-if="isShowTopupButton" as="span" text-decoration-line="underline" cursor="pointer" @click="onClickBanner">Top up balance</mp-box> -->
      <!-- </mp-box>
            </mp-flex>
            <mp-box v-show="!isAgent()" as="div" @click="onClickBanner">
              <mp-button variant="outline">
                {{
                  billingInfo.status === 'expired' ||
                  billingInfo.status === 'grace'
                    ? 'Customer support'
                    : 'Top up quota'
                }}
              </mp-button>
            </mp-box>
          </mp-flex>
        </mp-box> -->
      <!-- </mp-box> -->
      <mp-flex
        direction="column"
        class="mp-wrapper"
        :height="`calc(100vh - ${
          heightBannerMaintenance +
          heightBannerUserStatus +
          heightBannerCreditBalance
        }px)`"
      >
        <MpBox v-if="$route.path !== '/'">
          <TopNav v-if="isShowQontakOneTopNav" />
          <HeaderComponent
            v-else
            class="mp-header"
            :is-loading="isLoadingTopNav"
          />
        </MpBox>
        <mp-flex class="mp-main-body" as="main" flex="1" overflow="hidden">
          <Sidebar
            v-if="showQontakOneSidebar"
            :default-is-toggle="true"
            :is-alternate="false"
            :is-custom="true"
            :env="env"
            :env-data="envData"
            :spa-links="spaLinks"
            :sso-access-token="getSsoAccessToken()"
            :company-id="$auth.user ? $auth.user.company_id : ''"
            :hide-below-md="true"
            @error-fetch-menu="handleErrorFetchMenu"
          />
          <MekariSidebar
            v-else-if="$auth.user && $route.path !== '/restricted'"
            class="mp-sidebar"
            :banner-height-total="
              heightBannerMaintenance +
              heightBannerUserStatus +
              heightBannerCreditBalance
            "
            :menus="menuLists"
            :submenus="submenuLists"
            :has-sub-menu="submenuLists.length > 0"
            is-custom
            :default-is-toggle="sidebarDefaultIsToggle"
            :with-child="sidebarChildCondition()"
          />
          <mp-box
            as="section"
            class="mp-content"
            data-id="content"
            width="100%"
            :overflow-y="isMpContentOverflowAuto ? 'auto' : 'hidden'"
            height="100%"
          >
            <Nuxt />
            <InitComponent v-if="$auth.user" class="mp-init-component" />
            <ModalFreeze />
            <ModalPICValidation
              v-if="
                feature_flag_state?.company_validation?.state &&
                (isAdmin() || isSupervisor())
              "
            />
            <QontakCustomerCare
              v-if="isShowQontakCustomerCare"
              id="qontak-customer-care-widget"
              class="mp-widget-customer-care"
              :is-trial-user="billing_info.is_trial"
            />
            <CallWidget
              v-if="callWidget.isShow"
              class="mp-widget-call"
              :data="callWidget"
            />
          </mp-box>
        </mp-flex>
        <!--
          /**
           * @description: This is the old native sidebar that built without mekari pixel
           * this code currently is commented, cause there is possibility the code is will be using again
           */
        -->
        <!-- <mp-flex as="main" max-height="calc(100vh - 57px)">
          <Sidebar
            v-if="$auth.user"
            :menus="menuLists"
            :has-sub-menu="submenuLists.length > 0"
          />
          <SidebarChild
            v-if="sidebarChildCondition()"
            :menus="menuLists"
            :submenus="submenuLists"
          />
          <mp-box
            as="section"
            data-id="content"
            width="100%"
            height="calc(100vh - 57px)"
            overflow-y="auto"
          >
            <mp-box min-height="calc(100vh - 132px)" background-color="white">
              <nuxt />
            </mp-box>
          </mp-box>
        </mp-flex> -->
      </mp-flex>
    </mp-box>
    <Notification />
  </PixelWrapper>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
// import VueElementLoading from 'vue-element-loading'
import { deleteToken } from 'firebase/messaging'
// import Sidebar from './../components/layouts/main/Sidebar.vue'
// import SidebarChild from './../components/layouts/main/SidebarChild.vue'
import { MpBroadcast } from '@mekari/pixel'
import { Sidebar } from 'qontak-unified-component/packages/vue2'
import 'qontak-unified-component/packages/vue2/dist/style.css'

import InitComponent from './../components/layouts/main/InitComponent.vue'
import MekariSidebar from '~/components/layouts/main/MekariSidebar'
import HeaderComponent from '~/components/layouts/Header'
import PixelWrapper from '~/components/pixel_wrapper/PixelWrapper'
import QontakCustomerCare from '~/components/layouts/QontakCustomerCare'
import webchatV2WidgetMixin from '~/assets/mixins/webchat/webchatV2WidgetMixin'
import { generateCrmSignoutPayload } from '~/utils/auth'
import ModalFreeze from '~/components/UI/Modal/ModalFreezeStatusAccount.vue'
import ModalPICValidation from '~/components/UI/Modal/ModalPICValidation.vue'
import BannerMaintenance from '~/components/banner/banner-maintenance/index.vue'
import BannerUserStatus from '~/components/banner/banner-user-status/index.vue'
import BannerCreditBalance from '~/components/banner/banner-credit-balance/index.vue'
import QuotaBanner from '~/components/banner/quota-banner/index.vue'
import CallWidget from '~/components/layouts/call/CallWidget'
import { messaging } from '@/plugins/firebase'
import { isQontakLitePackage, validTokenCookie } from '~/utils/general'
import { isEnableQontakOneSidebar } from '~/utils/toggle'
import {
  getDefaultBannerCreditBalanceState,
  hasUnifiedQuotaBanner as hasUnifiedQuotaBannerUtil,
} from '~/utils/banner/unifiedQuotaBanner'
import urlMixin from '~/assets/mixins/global/urlMixin'
import TopNav from '~/components/layouts/qontak-one/TopNav.vue'
import Notification from '~/components/UI/Notification.vue'

export default {
  name: 'LayoutsHub',
  components: {
    Sidebar,
    PixelWrapper,
    // Sidebar,
    // SidebarChild,
    MekariSidebar,
    HeaderComponent,
    Notification,
    InitComponent,
    QontakCustomerCare,
    CallWidget,
    // VueElementLoading,
    ModalFreeze,
    ModalPICValidation,
    BannerMaintenance,
    BannerUserStatus,
    BannerCreditBalance,
    QuotaBanner,
    MpBroadcast,
    TopNav,
  },
  mixins: [urlMixin, webchatV2WidgetMixin],
  middleware: ['auth', 'settings', 'usman-init'],
  data() {
    return {
      fetchMenuFailed: false,
      enableUnifiedSidebar: isEnableQontakOneSidebar(),
      env: process.env.HUB_ENVIRONMENT || 'production',
      envData: {
        CRM_V1_HOST: process.env.CRM_URL,
        CRM_V2_HOST: process.env.CRM_URL_V2,
        CHAT_HOST: process.env.BASE_URL,
        IAG_SERVICE_URL: process.env.IAG_SERVICE_URL,
      },
      spaLinks: [
        '/inbox',
        '/dashboard/sla_overview',
        '/reports/general',
        '/reports/agent_performance',
        '/reports/broadcast/summary',
        '/reports/broadcast/activity',
        '/reports/contact',
        '/reports/csat',
        '/reports/ces',
        '/reports/nps',
        '/finances/package_usage',
        '/finances/chatbot_usage',
        '/finances/ask_airenes',
      ],
      parentMenu: '',
      bannerMaintenance: {
        isShow: false,
        date: {
          from: '',
          to: '',
        },
        message: '',
      },
      bannerCreditBalance: {
        isShow: false,
        message: '',
        isChatbot: false,
        isHideAction: false,
        bgColor: 'amber.100',
      },
      bannerUserStatus: {
        isShow: false,
        status: '',
        expiredInDays: 7,
      },
      bannerInformationNewPrice: {
        isShow: false,
      },
      isSingleBannerDismissed: false,
      dismissedBannerIndices: [],
    }
  },
  computed: {
    ...mapState('call', ['callWidget']),
    ...mapState('template', ['organization']),
    ...mapState('layouts', [
      'bannerMau',
      'quotaBanner',
      'loadingbar',
      'downtime',
      'bgColor',
      'appConfig',
      'heightBannerMaintenance',
      'heightBannerUserStatus',
      'heightBannerCreditBalance',
      'isFetchingAppConfig',
    ]),
    ...mapState('preferences', [
      'isInitiated',
      'feature_flag_state',
      'billing_info',
      'chatbot_subscription',
    ]),
    ...mapState('package', ['isUsePackageCode', 'isLoading']),
    ...mapState('organization', [
      'app_type',
      'permissions',
      'isFetchingOrganizationSettings',
    ]),
    ...mapState('unified_app', ['isUnifiedApp']),
    ...mapGetters('package', ['isEnableBillingPackage']),
    isDestyChatClient() {
      return this.isEnableBillingPackage('CP-QONTAKCHAT-2026-0004')
    },
    showQontakOneSidebar() {
      // show sidebar if qontak_one_nav is true or isUnifiedApp is true, and fetchMenuFailed is false
      return (
        (this.permissions?.qontak_one_nav || this.isUnifiedApp) &&
        !this.fetchMenuFailed
      )
    },
    isQontakLitePackage() {
      return isQontakLitePackage(this.billing_info)
    },
    isMpContentOverflowAuto() {
      return this.parentMenu === 'settings' || this.parentMenu === 'finances'
    },
    isMoveBannerEnabled() {
      return (
        this.billing_info && this.billing_info.is_move_banner_enabled === true
      )
    },
    isForceToShowQontakCustomerCare() {
      return this.appConfig?.is_force_to_show_qontak_customer_care || false
    },
    // billingInfo() {
    //   return this.$store.getters['preferences/getBillingInfo']
    // },
    // bannerInfo() {
    //   if (this.appConfig?.banner_info) {
    //     const now = new Date()
    //     const list = [
    //       'January',
    //       'February',
    //       'March',
    //       'April',
    //       'May',
    //       'June',
    //       'July',
    //       'August',
    //       'September',
    //       'October',
    //       'November',
    //       'December',
    //     ]
    //     const date = {
    //       from: {
    //         month:
    //           list[new Date(this.appConfig.banner_info.date.from).getMonth()],
    //         day: String(
    //           new Date(this.appConfig.banner_info.date.from).getDate()
    //         ).padStart(2, '0'),
    //         year: new Date(
    //           this.appConfig.banner_info.date.from
    //         ).getFullYear(),
    //         time: new Date(
    //           this.appConfig.banner_info.date.from
    //         ).toLocaleTimeString(),
    //       },
    //       to: {
    //         month:
    //           list[new Date(this.appConfig.banner_info.date.to).getMonth()],
    //         day: String(
    //           new Date(this.appConfig.banner_info.date.to).getDate()
    //         ).padStart(2, '0'),
    //         year: new Date(this.appConfig.banner_info.date.to).getFullYear(),
    //         time: new Date(
    //           this.appConfig.banner_info.date.to
    //         ).toLocaleTimeString(),
    //       },
    //     }

    //     const exactHoursFrom =
    //       new Date(this.appConfig.banner_info.date.from).getHours() === 0
    //         ? date.from.time.replace('12', '00')
    //         : date.from.time
    //     const exactHoursTo =
    //       new Date(this.appConfig.banner_info.date.to).getHours() === 0
    //         ? date.to.time.replace('12', '00')
    //         : date.to.time

    //     let output
    //     output = this.appConfig.banner_info.text.replace(
    //       '{{date}}',
    //       '<b>' +
    //         date.from.day +
    //         ' ' +
    //         date.from.month +
    //         ' ' +
    //         date.from.year +
    //         ' ' +
    //         '</b>'
    //     )
    //     output = output.replace('{{from}}', '<b>' + exactHoursFrom + '</b>')
    //     output = output.replace('{{to}}', '<b>' + exactHoursTo + '</b>')

    //     let isMaintenance = false
    //     const fromDate = new Date(this.appConfig.banner_info.date.from)
    //     const toDate = new Date(this.appConfig.banner_info.date.to)

    //     if (this.appConfig.banner_info.hideFrom.length < 1)
    //       isMaintenance = true

    //     if (
    //       this.$auth.user &&
    //       this.appConfig.banner_info.hideFrom.includes(
    //         this.$auth.user.organization_id
    //       )
    //     )
    //       isMaintenance = false
    //     else isMaintenance = true

    //     if (
    //       now >=
    //         fromDate.setHours(
    //           fromDate.getHours() -
    //             this.appConfig.banner_info.date.warn_before_hours
    //         ) &&
    //       now <= toDate
    //     ) {
    //       isMaintenance = true
    //     } else {
    //       isMaintenance = false
    //     }

    //     return {
    //       date,
    //       output,
    //       isMaintenance,
    //     }
    //   } else {
    //     return ''
    //   }
    // },
    user() {
      return this.$auth.user
    },
    feature() {
      return this.$store.state.preferences.feature
    },
    currentPage() {
      const [firstName] = this.$route.name.split('-')

      return firstName || 'no_route'
    },
    sidebarDefaultIsToggle() {
      // Auto expand sidebar when use_new_channel_integration_page is true and current page is integrations
      if (
        this.currentPage === 'integrations' &&
        this.permissions?.use_new_channel_integration_page
      ) {
        return false // false means expanded
      }
      return true // true means collapsed by default
    },
    menuLists() {
      const menus = []
      const menusToHide = []

      // disable permission validation from here to prevent overlapping
      // use permission inside the side bar (MekariSidebar) component
      // preserve the logic for now, remove later if not needed
      // if (
      //   !this.billing_info.sla_dashboard_enabled &&
      //   !this.permissions?.customer_insights
      // )
      //   menusToHide.push('Dashboard')

      if (!this.chatbot_subscription.airene_resource_enabled)
        menusToHide.push('AI resources')

      if (!this.appConfig?.is_show_menu_custom_solutions)
        menusToHide.push('Custom Solutions')

      if (this.feature?.menu) {
        Object.keys(this.feature.menu).forEach((menu) => {
          let redirectLink = ``
          if (menu === 'whatsapp') {
            redirectLink = `/${this.feature.menu[menu].slug}`
          } else {
            redirectLink = this.feature.menu[menu].redirect
              ? `/${this.feature.menu[menu].slug}/${this.feature.menu[menu].redirect}`
              : `/${this.feature.menu[menu].slug}`
          }
          if (this.feature.menu[menu].status) {
            const baseMenuData = {
              id: `${this.feature.menu[menu].title}-${this.feature.menu[menu].category}`,
              name: this.feature.menu[menu].title,
              icon: this.feature.menu[menu].icon,
              link: redirectLink,
              isActive: this.currentPage.includes(this.feature.menu[menu].slug),
              category: this.feature.menu[menu].category,
              slug: this.feature.menu[menu].slug,
              isNew: this.feature.menu[menu].isNew,
            }

            if (!menusToHide.includes(baseMenuData.name))
              menus.push(baseMenuData)
          }
        })
      }

      return _.sortBy(menus, [
        function (menu) {
          return menu.category
        },
      ])
    },
    submenuLists() {
      const submenus = []
      const currentRoute = this.$route.name
      const submenusOfMenu = _.filter(
        this.feature.submenu,
        function (data) {
          return data.parent === this.existingPage
        }.bind({ existingPage: this.currentPage })
      )
      const splitRoute = currentRoute.split('-')
      const routeIsSettings = splitRoute[0] === 'settings'
      if (
        routeIsSettings &&
        this.permissions?.security_settings &&
        this.isAdmin() &&
        !this.isQontakLitePackage
      ) {
        const securitySubmenu = [
          {
            title: 'Security',
            slug: 'security',
            status: this.permissions?.security_settings,
            parent: 'settings',
            icon: 'chat',
            code: 'security',
          },
        ]
        const tokenSubmenuIndex = submenusOfMenu.findIndex(
          (submenu) => submenu.slug === 'token'
        )
        if (tokenSubmenuIndex)
          submenusOfMenu.splice(tokenSubmenuIndex, 0, ...securitySubmenu)
        else submenusOfMenu.push(securitySubmenu)
      }

      submenusOfMenu.forEach((submenu, index) => {
        // map child sub menu
        let childSubmenuLists = []
        if (this.feature.childsubmenu) {
          Object.keys(this.feature.childsubmenu).forEach((child) => {
            if (
              this.feature.childsubmenu[child].submenuparent === submenu.slug &&
              this.feature.childsubmenu[child].menuparent === submenu.parent
            ) {
              childSubmenuLists.push({
                ...this.feature.childsubmenu[child],
                isActive:
                  this.$route.path ===
                  `/${this.feature.childsubmenu[child].slug}`,
              })
            }
          })
          if (this.app_type === 'outbound') {
            childSubmenuLists = childSubmenuLists.filter(
              (item) => item.slug !== 'settings/token/chatbot'
            )
          }
        }

        if (submenu.status) {
          const baseSubmenusData = {
            id: `${submenu.parent}-${submenu.slug}`,
            name: submenu.title,
            status: submenu.status,
            isActive: currentRoute.split('-')[1] === submenu.slug,
            link: `/${this.$route.fullPath.split('/')[1]}/${submenu.slug}`,
            icon: submenu.icon,
            child: childSubmenuLists,
            isNew: submenu.isNew,
            index,
          }
          submenus.push(baseSubmenusData)
        }
      })
      return submenus.filter((submenu) => submenu.status)
    },
    isShowQontakCustomerCare() {
      // One support entry: the Webchat V2 bubble takes the same corner.
      if (this.isWebchatV2WidgetMounted) return false
      // if this.$auth.user && !this.isQontakLitePackage && isForceToShow is true, then always return true
      // defaultnya previous validation only = this.$auth.user && !this.isQontakLitePackage
      if (
        this.$auth.user &&
        !this.isQontakLitePackage &&
        this.isForceToShowQontakCustomerCare
      ) {
        return true
      }
      return (
        this.$auth.user &&
        !this.isQontakLitePackage &&
        !this.permissions.disable_wa_icon
      )
    },
    isShowQontakOneTopNav() {
      return this.permissions?.qontak_one_nav && this.isUnifiedApp
    },
    isLoadingTopNav() {
      return (
        this.isLoading ||
        this.isFetchingOrganizationSettings ||
        this.isFetchingAppConfig
      )
    },
    isUnifiedQuotaBannerVisible() {
      return Boolean(
        this.quotaBanner &&
          this.quotaBanner.isFeatureActive === true &&
          this.quotaBanner.message
      )
    },
  },
  watch: {
    callWidget: {
      handler(newVal) {
        const isShow = !!(
          this.$auth.user &&
          this.permissions.enable_wa_call &&
          newVal.user.fullname
        )
        if (this.callWidget.isShow !== isShow) {
          this.$store.commit('call/UPDATE_CALL_WIDGET', {
            isShow,
          })
        }
      },
      deep: true,
    },
    'bannerMaintenance.isShow': {
      handler(newValue) {
        if (!newValue)
          this.$store.commit('layouts/SET_HEIGHT_BANNER_MAINTENANCE', 0)
      },
      deep: true,
    },
    'bannerCreditBalance.isShow': {
      handler(newValue) {
        if (!newValue)
          this.$store.commit('layouts/SET_HEIGHT_BANNER_CREDIT_BALANCE', 0)
      },
      deep: true,
    },
    'bannerUserStatus.isShow': {
      handler(newValue) {
        if (!newValue)
          this.$store.commit('layouts/SET_HEIGHT_BANNER_USER_STATUS', 0)
      },
      deep: true,
    },
    'appConfig.banner_info': {
      handler(newValue) {
        if (newValue && Object.keys(newValue).length > 0) {
          const date = this.getNewDate(newValue.date)
          const message = this.getMessage(date, newValue)
          const isShow = this.getIsShow(newValue)
          this.bannerMaintenance.isShow = isShow
          this.bannerMaintenance.date = date
          this.bannerMaintenance.message = message
        } else {
          this.bannerMaintenance.isShow = false
        }
      },
      deep: true,
    },
    $route() {
      const path = this.$route.path
      const [, parentMenu] = path.split('/')
      this.parentMenu = parentMenu
    },
    billing_info: {
      handler(newValue) {
        if (!newValue) return

        const { status, is_trial: isTrial, valid_until: validUntil } = newValue
        const expiredTrialDays = this.getExpiredTrial(validUntil)
        const isStatusExpiredSoon =
          expiredTrialDays <= parseInt(this.bannerUserStatus.expiredInDays) &&
          expiredTrialDays >= 0 &&
          !this.isAgent() &&
          !isTrial

        if (status === 'freeze') {
          this.bannerUserStatus.isShow = true
          this.bannerUserStatus.status = 'freeze'
        } else if (isTrial) {
          this.bannerUserStatus.isShow = true
          this.bannerUserStatus.status = 'trial'
        } else if (isStatusExpiredSoon) {
          this.bannerUserStatus.isShow = true
          this.bannerUserStatus.status = 'is_expired_soon'
        }
      },
      deep: true,
    },
    bannerMau: {
      handler(newValue) {
        if (this.hasUnifiedQuotaBanner()) {
          this.bannerCreditBalance.isShow = false
          return
        }

        this.resetBannerCreditBalanceState()

        // Exclude unused properties related to show banner
        const alerts = newValue && newValue.alerts ? newValue.alerts : {}
        const nameAlertToShow = { ...alerts }
        const propertiesToRemove = ['is_new_activation']
        for (const alertsName of propertiesToRemove) {
          delete nameAlertToShow[alertsName]
        }

        if (
          Object.keys(newValue).length > 0 &&
          Object.values(nameAlertToShow).some((item) => item)
        ) {
          this.bannerCreditBalance.isShow = true
          this.bannerCreditBalance.message = this.onCheckingMessage(
            newValue.alerts
          )
        } else {
          this.bannerCreditBalance.isShow = false
        }
      },
    },
    'appConfig.banner_wa_new_price_information': {
      handler(newValue) {
        if (newValue) {
          this.bannerInformationNewPrice.isShow = true
        }
      },
      deep: true,
    },
    'appConfig.is_banner_user_status_expired_in_days': {
      handler(newVal) {
        if (newVal) {
          this.bannerUserStatus.expiredInDays = newVal
          this.showBannerExpiredSoon()
        }
      },
    },
  },
  mounted() {
    this.onFetchBannerMau()
    this.onFetchQuotaBanner()
  },
  methods: {
    getSsoAccessToken() {
      return validTokenCookie()
    },
    handleErrorFetchMenu(_) {
      this.fetchMenuFailed = true
    },
    getIsShow(bannerInfo) {
      const now = new Date()
      let isShow = false
      const fromDate = new Date(bannerInfo.date.from)
      const toDate = new Date(bannerInfo.date.to)

      if (bannerInfo.hideFrom.length < 1) isShow = true
      if (
        this.$auth.user &&
        bannerInfo.hideFrom.includes(this.$auth.user.organization_id)
      )
        isShow = false
      else isShow = true

      if (
        now >=
          fromDate.setHours(
            fromDate.getHours() - bannerInfo.date.warn_before_hours
          ) &&
        now <= toDate
      ) {
        isShow = true
      } else {
        isShow = false
      }
      return isShow
    },
    getMessage(date, bannerInfo) {
      const exactHoursFrom =
        new Date(bannerInfo.date.from).getHours() === 0
          ? date.from.time.replace('12', '00')
          : date.from.time
      const exactHoursTo =
        new Date(bannerInfo.date.to).getHours() === 0
          ? date.to.time.replace('12', '00')
          : date.to.time

      let message
      message = bannerInfo.text.replace(
        '{{date}}',
        '<b>' +
          date.from.day +
          ' ' +
          date.from.month +
          ' ' +
          date.from.year +
          ' ' +
          '</b>'
      )
      message = message.replace('{{from}}', '<b>' + exactHoursFrom + '</b>')
      message = message.replace('{{to}}', '<b>' + exactHoursTo + '</b>')
      return message
    },
    getNewDate(date) {
      const list = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      return {
        from: {
          month: list[new Date(date.from).getMonth()],
          day: String(new Date(date.from).getDate()).padStart(2, '0'),
          year: new Date(date.from).getFullYear(),
          time: new Date(date.from).toLocaleTimeString(),
        },
        to: {
          month: list[new Date(date.to).getMonth()],
          day: String(new Date(date.to).getDate()).padStart(2, '0'),
          year: new Date(date.to).getFullYear(),
          time: new Date(date.to).toLocaleTimeString(),
        },
      }
    },
    onCloseBannerItem(idx) {
      this.dismissedBannerIndices = [...this.dismissedBannerIndices, idx]
    },
    onCloseBannerStatus(value) {
      this.bannerUserStatus.isShow = value
      !value &&
        this.$emit('set-banner-height', {
          type: 'user-status',
          value: 0,
        })
    },
    setBannerHeight({ type, value }) {
      switch (type) {
        case 'maintenance':
          this.$store.commit('layouts/SET_HEIGHT_BANNER_MAINTENANCE', value)
          break
        case 'user-status':
          this.$store.commit('layouts/SET_HEIGHT_BANNER_USER_STATUS', value)
          break
        case 'credit-balance':
          this.$store.commit('layouts/SET_HEIGHT_BANNER_CREDIT_BALANCE', value)
          break
        default:
          break
      }
    },
    onClickBanner() {
      if (this.$store.state.preferences.feature_flag_state.self_topup.state) {
        if (
          this.billing_info.billing_enabled &&
          this.billing_info.payment_type === 'prepaid' &&
          !this.billing_info.is_trial &&
          this.billing_info.status === 'active' &&
          !this.bannerCreditBalance.isChatbot
        ) {
          this.goToTopUpPage()
        } else {
          this.redirectToCustomerCare()
        }
      } else {
        this.redirectToCustomerCare()
      }
    },
    redirectToCustomerCare() {
      if (this.isDestyChatClient && this.appConfig?.homepage_url_desty) {
        window.open(this.appConfig.homepage_url_desty)
      } else if (this.billing_info.is_trial) {
        window.open(
          'https://wa.me/6281287090263?&text=[Q4H-02K]%20Halo,%20saya%20sudah%20menggunakan%20akun%20trial%20dan%20ingin%20berlangganan%20Omnichanel%20Qontak'
        )
      } else {
        window.open('https://app.qontak.com/contact-support')
      }
    },
    onCheckingMessage(alerts) {
      this.resetBannerCreditBalanceState()

      let message = ''
      if (alerts.is_has_debt) {
        message =
          'Your whatsapp balance is now below Rp0. Top up your balance to receive or send WhatsApp messages.'
      } else if (alerts.is_mcc_over && alerts.is_muv_over) {
        message =
          "You're out of <b>WhatsApp balance</b> and <b>unique visitor credits.</b> Please top up to restore your access."
      } else if (alerts.is_mcc_over) {
        message =
          'You’re out of WhatsApp balance. To restore your access, please top up your balance.'
      } else if (alerts.is_muv_over) {
        message =
          "You're out of <b>Unique visitor quota.</b> To keep your access, please top up your balance."
      } else if (alerts.is_mcc_over_soon && alerts.is_muv_over_soon) {
        message =
          'You’re running out of <b>WhatsApp balance</b> and <b>unique visitor credits.</b> Please top up to keep your access.'
        this.bannerCreditBalance.bgColor = 'violet.400'
        if (this.isAgent())
          message = 'Your MUV/MCC quota is approaching the usage limit of 40%.'
      } else if (alerts.is_mcc_over_soon) {
        message =
          'You’re running out of <b>WhatsApp balance.</b> To keep your access, please top up your balance.'
        this.bannerCreditBalance.bgColor = 'violet.400'
        if (this.isAgent())
          message = 'Your MCC quota is approaching the usage limit of 40%.'
      } else if (alerts.is_muv_over_soon) {
        message =
          'Your MUV quota is approaching the usage limit of 40%. Immediately Top Up your quota via Self Top Up.'
        this.bannerCreditBalance.bgColor = 'violet.400'
        if (this.isAgent())
          message = 'Your MUV quota is approaching the usage limit of 40%.'
      } else if (alerts.is_package_inactive) {
        message =
          'Your package is expired. To continue your access, please contact our support team.'
      } else if (alerts.is_chatbot_ai_running_out) {
        this.bannerCreditBalance.isChatbot = true
        message =
          "You're running out of <b>chatbot AI dialog.</b> To use AI for your chatbot, top up your quota by contacting our support team."
      } else if (alerts.is_chatbot_ai_run_out) {
        this.bannerCreditBalance.isChatbot = true
        message =
          "You're out of <b>chatbot AI dialog.</b> To use AI for your chatbot, top up your quota by contacting our support team."
      } else if (alerts.is_airene_package_running_out) {
        message = `You're running out of <b>Ask Airene credits.</b> The credits will reset on the first day of the next month.`
        this.bannerCreditBalance.isChatbot = true
        this.bannerCreditBalance.isHideAction = true
        this.bannerCreditBalance.bgColor = 'violet.400'
      } else if (alerts.is_airene_package_run_out) {
        message = `You are out of <b>Ask Airene credits.</b> The credits will reset on the first day of the next month.`
        this.bannerCreditBalance.isChatbot = true
        this.bannerCreditBalance.isHideAction = true
        this.bannerCreditBalance.bgColor = 'amber.100'
      } else if (alerts.is_voice_package_running_out) {
        this.bannerCreditBalance.isChatbot = true
        this.bannerCreditBalance.isHideAction = false
        this.bannerCreditBalance.bgColor = 'violet.400'
        message =
          "You're running out of <b>Call balance.</b> To keep your access, please contact our support team."
      } else if (alerts.is_voice_package_run_out) {
        this.bannerCreditBalance.isChatbot = true
        this.bannerCreditBalance.isHideAction = false
        this.bannerCreditBalance.bgColor = 'amber.100'
        message =
          "You're out of <b>Call balance.</b> To restore your access, top up your balance by contacting our support team."
      } else if (alerts.is_new_activation) {
        message = ''
      } else {
        message = ''
      }
      return message
    },
    hasUnifiedQuotaBanner() {
      return hasUnifiedQuotaBannerUtil(this.quotaBanner || {})
    },
    resetBannerCreditBalanceState() {
      const defaultState = getDefaultBannerCreditBalanceState()
      this.bannerCreditBalance.isChatbot = defaultState.isChatbot
      this.bannerCreditBalance.isHideAction = defaultState.isHideAction
      this.bannerCreditBalance.bgColor = defaultState.bgColor
    },
    async onFetchBannerMau() {
      if (this.$auth.user) {
        await this.$store
          .dispatch('layouts/getBannerMau', {
            organization_id: this.$auth.user.organization_id,
          })
          .catch((err) => {
            const errorCode = err?.error?.code || null
            if (errorCode === 401 && !this.isSuperAdmin()) {
              setTimeout(async () => {
                if (
                  this.browser_type !== 'Safari' &&
                  localStorage.getItem('subscribe_token')
                ) {
                  this.removeCurrentSubsToken()
                  // this.$fire.messaging.deleteToken(localStorage.getItem('subscribe_token'))
                  if ((this.isAgent() || this.isSupervisor()) && this.is_online)
                    this.$nuxt.$emit('onLoggedOut')
                  await deleteToken(
                    messaging,
                    localStorage.getItem('subscribe_token')
                  )
                  this.storeMixpanelMetric('[USER LOGOUT]', {
                    from: 'layouts/hub.vue - onFetchBannerMau()',
                    user_id: this.$auth.user.id,
                    organization_id: this.$auth.user.organization_id,
                    role: this.$auth.user.role,
                    email: this.$auth.user.email,
                    cid: this.$auth.company_id,
                  })
                  await this.$auth.logout({
                    token: this.$auth.getToken('hub')?.split(' ')[1],
                    ...generateCrmSignoutPayload(),
                  })
                }
                location.reload()
              }, 3000)
            }
          })
      }
    },
    async onFetchQuotaBanner() {
      if (!this.$auth.user || !process.env.IAG_SERVICE_URL) {
        return
      }

      await this.$store.dispatch('layouts/getQuotaBanner')
    },
    async removeCurrentSubsToken() {
      await this.$store
        .dispatch('fcm/removePreviousFcmToken', {
          token: localStorage.getItem('subscribe_token'),
        })
        .then((message) => {
          localStorage.removeItem('subscribe_token')
        })
        .catch((err) => {
          throw err
        })
      localStorage.removeItem('subscribe_token')
    },
    sidebarChildCondition() {
      const toggleChatbotAI = this.appConfig?.is_display_chatbot_usage

      // Hide sidebar child for integrations when use_new_channel_integration_page is true
      if (
        this.currentPage === 'integrations' &&
        this.permissions?.use_new_channel_integration_page
      ) {
        return false
      }

      if (toggleChatbotAI) {
        return this.$auth.user && this.submenuLists.length > 0
      } else {
        return (
          this.$auth.user &&
          this.submenuLists.length > 0 &&
          !this.$route.name.includes('finances-package_usage')
        )
      }
    },
    handleCloseBannerInformation() {
      this.bannerInformationNewPrice.isShow = false
    },
    handleClickLinkBannerInformation() {
      window.open(
        'https://help-center.qontak.com/hc/id/articles/10265853268121-Bagaimana-Cara-Mengelola-Package-Usage-Conversation'
      )
    },
    getExpiredTrial(date) {
      const unixdate = this.$moment.unix(date).format('YYYY-MM-DD')
      const expiredDate = this.$moment(unixdate).utc()
      const todaysDate = this.$moment().utc()
      return expiredDate.diff(todaysDate, 'days')
    },
    showBannerExpiredSoon() {
      const { is_trial: isTrial, valid_until: validUntil } = this.billing_info
      const expiredTrialDays = this.getExpiredTrial(validUntil)
      const isStatusExpiredSoon =
        expiredTrialDays <= parseInt(this.bannerUserStatus.expiredInDays) &&
        expiredTrialDays >= 0 &&
        !this.isAgent() &&
        !isTrial
      if (isStatusExpiredSoon) {
        this.bannerUserStatus.isShow = true
        this.bannerUserStatus.status = 'is_expired_soon'
      }
    },
  },
}
</script>
